import React from "react";
import Telephones from "../Telephones";
function School(props) {
  return (
    <li className="item item-container">
      <div className="attribute school-name">
        {props.name} {props.grades ? `(${props.grades})` : ""}
      </div>
      <div className="attribute" data-name="">
        {props.distName}
      </div>
      <div className="attribute administrator" data-name="">
        <div>{props.administrator}</div>
      </div>
      <div className="attribute-container">
        {props.paddr || props.maddr ? (
          <React.Fragment>
            <div className="attribute address-and-map" data-name="">
              <span>{props.paddr ? props.paddr : props.maddr}</span>
            </div>
            {props.paddr && props.maddr ? (
              <div className="attribute" data-name="">
                {props.paddr ? props.maddr : ""}
              </div>
            ) : (
              <div className="attribute"></div>
            )}
            <div className="attribute city-state-zip" data-name="">
              {props.city}, CA {props.zip}
            </div>
            <div className="attribute map-link" data-name="">
              <a
                href={`http://www.google.com/maps?q=${props.name.replace(
                  /[()]/g,
                  ""
                )}+${
                  props.paddr ? props.paddr : props.maddr
                }&amp;ie=UTF8&amp;iwloc=addr`}
                target="_blank"
                rel="noopener noreferrer"
                title="Google Map"
              >
                MAP
              </a>
            </div>
          </React.Fragment>
        ) : (
          <div className="attribute"></div>
        )}
      </div>

      <div className="attribute school-phone" data-name="">
        <Telephones phonesString={props.phone}></Telephones>
      </div>
      <div className="attribute-container">
        {props.website ? (
          <div className="attribute school-website" data-name="">
            <React.Fragment>
              <a
                href={`http://${props.website}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.website}
              </a>
            </React.Fragment>
          </div>
        ) : (
          <div className="attribute"></div>
        )}
        <div className="attribute dashboard" data-name="">
          <a
            href={`https://www.caschooldashboard.org/reports/${props.cdsCode}/${props.cdeYear}`}
            aria-label={`Dashboard report for ${props.name}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            CA School Dashboard Report
          </a>
        </div>
      </div>
    </li>
  );
}
export default School;
